"use strict";

define(['marionette'], function (Marionette) {
  return Marionette.ItemView.extend({
    template: false,
    initialize: function initialize() {
      this.bindUIElements();
    }
  });
});